import React from 'react';
import './Contact.css';
import Navbar from './Navbar';
import { FaPhone, FaEnvelope, FaLinkedin, FaGithub, FaTwitter } from 'react-icons/fa';

function Contact() {
  return (
    <div>
      <Navbar />
      <div className="contact-container">
        <div className="contact-details">
          <h1>Contact Me</h1>
          <ul className="contact-list">
            <li>
              <FaPhone className="contact-icon" />
              <a href="tel:+91798956990">+91 7989569990</a>
            </li>
            <li>
              <FaEnvelope className="contact-icon" />
              <a href="mailto:shivabollam07@gmail.com">shivabollam07@gmail.com</a>
            </li>
            <li>
              <FaLinkedin className="contact-icon" />
              <a href="https://www.linkedin.com/in/bollam-shiva-a04062222/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </li>
            <li>
              <FaGithub className="contact-icon" />
              <a href="https://github.com/ShivaBollam07" target="_blank" rel="noopener noreferrer">GitHub</a>
            </li>
            <li>
              <FaTwitter className="contact-icon" />
              <a href="https://twitter.com/BollamShivasha2" target="_blank" rel="noopener noreferrer">Twitter</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Contact;
